<div class="container-fluid">
  <h3>Accounting</h3>

  <div *ngIf="loading" class="text-center py-5">
    <i class="fas fa-spinner fa-spin fa-2x"></i>
    <p>Loading accounting data...</p>
  </div>

  <div *ngIf="error" class="alert alert-danger">
    {{ error }}
  </div>

  <div *ngIf="!loading && data">
    <!-- Bank Balances -->
    <h4>Bank Balances</h4>
    <table class="table table-striped">
      <thead>
        <tr>
          <th>Bank</th>
          <th class="text-right">Ledger</th>
          <th class="text-right">- Balance</th>
          <th class="text-right">Difference</th>
          <th class="text-right">(Outstanding Receipts)</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let bank of data.bank_balances">
          <td>
            <a [routerLink]="['/bank_accounts', bank.id]">{{ bank.name }}</a>
          </td>
          <td class="text-right">{{ formatMoney(bank.ledger) }}</td>
          <td class="text-right">{{ formatMoney(bank.balance) }}</td>
          <td class="text-right">
            <i *ngIf="bank.has_diff" class="fas fa-exclamation-triangle text-warning"></i>
            {{ formatMoney(bank.diff) }}
          </td>
          <td class="text-right">
            <a [href]="'/deposits/new?bank_account_id=' + bank.id">
              {{ formatMoney(bank.waiting) }}
            </a>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Checks In Transit -->
    <h4>Checks In Transit</h4>
    <table class="table" style="width: 75%">
      <thead>
        <tr>
          <th class="text-right">Ledger</th>
          <th class="text-right">- Outstanding Receipts</th>
          <th class="text-right">Difference</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="text-right">{{ formatMoney(data.checks_in_transit.ledger) }}</td>
          <td class="text-right">{{ formatMoney(data.checks_in_transit.waiting_to_be_deposited) }}</td>
          <td class="text-right">
            <i *ngIf="data.checks_in_transit.has_diff" class="fas fa-exclamation-triangle text-warning"></i>
            {{ formatMoney(data.checks_in_transit.diff) }}
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Held In Escrow -->
    <h4>Held In Escrow</h4>
    <table class="table" style="width: 75%">
      <thead>
        <tr>
          <th class="text-right">Ledger</th>
          <th class="text-right">- Bills</th>
          <th class="text-right" colspan="2">Difference</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="text-right">{{ formatMoney(data.escrow.ledger) }}</td>
          <td class="text-right">
            <a [routerLink]="['/bills']" [queryParams]="{'search[entries.bill_type_id]': data.escrow.bill_type_id}">
              {{ formatMoney(data.escrow.bills) }}
            </a>
          </td>
          <td class="text-right" colspan="2">
            <i *ngIf="data.escrow.has_ledger_bills_diff" class="fas fa-exclamation-triangle text-warning"></i>
            {{ formatMoney(data.escrow.ledger_bills_diff) }}
          </td>
        </tr>
      </tbody>
    </table>

    <table class="table" style="width: 75%">
      <thead>
        <tr>
          <th class="text-right">Ledger</th>
          <th class="text-right">- (Bank Balance</th>
          <th class="text-right">+ Outstanding Escrow Receipts)</th>
          <th class="text-right">Difference</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="text-right">{{ formatMoney(data.escrow.ledger) }}</td>
          <td class="text-right">{{ formatMoney(data.escrow.balance) }}</td>
          <td class="text-right">{{ formatMoney(data.escrow.waiting_total) }}</td>
          <td class="text-right">
            <i *ngIf="data.escrow.has_ledger_balance_diff" class="fas fa-exclamation-triangle text-warning"></i>
            {{ formatMoney(data.escrow.ledger_balance_diff) }}
          </td>
        </tr>
      </tbody>
    </table>

    <table class="table" style="width: 75%">
      <thead>
        <tr>
          <th class="text-right">Bills</th>
          <th class="text-right">- (Bank Balance</th>
          <th class="text-right">+ Outstanding Escrow Receipts)</th>
          <th class="text-right">Difference</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="text-right">
            <a [routerLink]="['/bills']" [queryParams]="{'search[entries.bill_type_id]': data.escrow.bill_type_id}">
              {{ formatMoney(data.escrow.bills) }}
            </a>
          </td>
          <td class="text-right">{{ formatMoney(data.escrow.balance) }}</td>
          <td class="text-right">{{ formatMoney(data.escrow.waiting_total) }}</td>
          <td class="text-right">
            <i *ngIf="data.escrow.has_bills_balance_diff" class="fas fa-exclamation-triangle text-warning"></i>
            {{ formatMoney(data.escrow.bills_balance_diff) }}
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Ledger -->
    <h4>Ledger</h4>
    <table class="table" style="width: 75%">
      <thead>
        <tr>
          <th class="text-right">Credit - Debit</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="text-right">
            <i *ngIf="data.ledger.balance !== 0" class="fas fa-exclamation-triangle text-warning"></i>
            {{ formatMoney(data.ledger.balance) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
